/**
 * Author: Ivan Horobets
 * Email: vanzzosolutions@gmail.com
 * Company: VanzzoSolutions
 */

"use strict";

//Classes type
import StopScroll from './classes/StopScrollClass';
import UtilsClass from './classes/UtilsClass';

const utilsClass = new UtilsClass();
const W = window.innerWidth;

/**
 * Cut string length
 */
if(W >= 768) {

    let $strCuts = document.querySelectorAll('[data-cut-str]');
    for (let i = 0; i < $strCuts.length; i++) {
        $strCuts[i].innerHTML = cutStr(
            $strCuts[i].innerHTML,
            $strCuts[i].getAttribute('data-cut-length'),
        );
    }

    // Show\hide text
    let $strToggle = document.querySelectorAll('.cut-str-control');
    for (let i = 0; i < $strToggle.length; i++) {
        $strToggle[i].onclick = function () {
            this.classList.toggle('open');
            let $containerText = this.previousElementSibling;
            if(this.classList.contains('open')) {
                $containerText.innerHTML = $containerText.getAttribute('data-cut-str');
            } else {
                $containerText.innerHTML = cutStr(
                    $containerText.getAttribute('data-cut-str'),
                    $containerText.getAttribute('data-cut-length'),
                );
            }
        }
    }

    function cutStr (string, length) {
        return string.length > length ? string.substring(0, length) + "..." : string;
    }
}


/**
 * Menu open\close
 */
if(W <= 767) {
    let $menuMobOpen = document.getElementById('open-mob-menu'),
        $menuMobCloe = document.getElementById('close-mob-menu'),
        $mobMenuWrap = document.getElementById('mob-menu');

    let $openLanguage = document.getElementById('to-language'),
        $closeLanguage = document.getElementById('to-menu'),
        $wrapLanguage = document.getElementById('language-menu');

    const stopScrollMenu = new StopScroll($mobMenuWrap, '#mob-menu');

    if($menuMobOpen) {
        $menuMobOpen.onclick = function (e) {
            e.preventDefault();
            $mobMenuWrap.classList.add('open');
            stopScrollMenu.disableScroll();
        }
        $menuMobCloe.onclick = function (e) {
            e.preventDefault();
            $mobMenuWrap.classList.remove('open');
            $wrapLanguage.classList.remove('open');
            stopScrollMenu.enableScroll();
        }
    }

    // Language change
    if($openLanguage) {
        $openLanguage.onclick = function (e) {
            e.preventDefault();
            $wrapLanguage.classList.add('open');
        }
        $closeLanguage.onclick = function (e) {
            e.preventDefault();
            $wrapLanguage.classList.remove('open');
        }
    }
}

if(W >= 768) {
    let timerClose = null,
        $langArea = document.querySelector('.language-switcher');
    $langArea.addEventListener("mouseenter", function() {
        clearTimeout(timerClose);
        if(!$langArea.classList.contains('open')) {
            $langArea.classList.add('open');
        }
    });

    $langArea.addEventListener("mouseout", function() {
        timerClose = setTimeout(function (){
            $langArea.classList.remove('open');
        }, 200);
    });
}

/**
 * Anchor scroll
 */

let $toContacts = document.querySelectorAll('.to-insert-contact');
if($toContacts.length) {
    let $contactSection = document.getElementById('contact-section');
    for (let i = 0; i < $toContacts.length; i++) {
        $toContacts[i].onclick = function (e) {
            e.preventDefault();

            if(e.target.parentNode.classList.contains('cut-str-control')) return true;

            document.querySelector('input[name="come_from"]').value = this.getAttribute('data-id');
            window.scrollTo({ top: $contactSection.offsetTop, behavior: 'smooth'});
        };
    }
}

/**
 * Contact form
 */
window.onload = function() {
    const TIME_DELAY_MS = 2000;

    let $phonesInput = document.querySelectorAll('input[type="tel"]');
    if($phonesInput.length) {
        setTimeout(function () {
            utilsClass.callbackLoadScript(TEMPLATE_URL + '/dist/js/imask.js', function () {
                let maskOptions = {
                    mask: '+{00} 00 0000 00 00'
                };
                for(let i = 0; i < $phonesInput.length; i++) {
                    let mask = IMask($phonesInput[i], maskOptions);
                }
            });
        }, TIME_DELAY_MS);
    }

    // Push all to email
    let $tf = document.getElementById('sent-email');
    setTimeout(function () {
        if (typeof ($tf) != 'undefined' && $tf != null) {
            utilsClass.callbackLoadScript(TEMPLATE_URL + '/dist/js/jquery-3.4.1.min.js', function () {
                utilsClass.callbackLoadScript(TEMPLATE_URL + '/dist/js/jquery.validate.min.js', function () {
                    $($tf).validate({
                        errorClass: "error",
                        validClass: "valid",
                        highlight: function (element, errorClass, validClass) {
                            $(element).addClass(errorClass).removeClass(validClass);
                            $(element).closest('.input-wrap').addClass(errorClass).removeClass(validClass);
                        },
                        unhighlight: function (element, errorClass, validClass) {
                            $(element).addClass(validClass).removeClass(errorClass);
                            $(element).closest('.input-wrap').addClass(validClass).removeClass(errorClass);
                        },
                        errorPlacement: function (error, element) {
                            return true;
                        },
                        submitHandler: function (form) {
                            let $form = $(form);
                            let dataToSave = new FormData($form[0]);

                            //Push all to server

                            $(form).find('button[type="submit"]').prop('disabled', true);
                            var xhr = new XMLHttpRequest();
                            xhr.open('post', TEMPLATE_URL + '/saveData.php', true);
                            xhr.send(dataToSave);
                            xhr.onload = function () {
                                if (this.response === 'ok') {
                                    $form[0].reset();
                                    showThanxPopup();
                                }

                                $(form).find('button[type="submit"]').prop('disabled', false);
                            };
                        }
                    });
                })
            });
        }
    }, TIME_DELAY_MS);

    let $thanxPopup = document.getElementById('thanx-popap-js'),
        $overlay = document.querySelector('.overlay-page');

    const stopScrollThanx = new StopScroll($thanxPopup, '#thanx-popap-js');

    let $closeThanxBtns = document.querySelectorAll('.close-thanx-popup');
    for(let i = 0; i < $closeThanxBtns.length; i++) {
        $closeThanxBtns[i].onclick = function (e) {
            e.preventDefault();
            hideThanxPopup();
        }
    }

    function showThanxPopup() {
        $thanxPopup.classList.add('open');
        $overlay.classList.add('open');
        stopScrollThanx.disableScroll();
    }
    function hideThanxPopup() {
        $thanxPopup.classList.remove('open');
        $overlay.classList.remove('open');
        stopScrollThanx.enableScroll();
    }
}

